import { Record } from 'immutable';

export class XDLineItem extends Record({
  id: '',
  name: "",
  baseCost: 0,
  costPerUnit: 0,
  labourCostPerUnit: 0,
  unit: 'ft',
  minLengthArea: 0,
  minLengthAreaUnit: 'ft',
}, 'XDLineItem') {
  constructor(json = {}) {
    super({
      ...json,
    });
  }
}

export class XDLineItemRef extends Record({
  id: '',
  quantity: 'auto', // number or 'auto'
  bSideA: true,
  bSideB: true,
}, 'XDLineItemRef') {
  constructor(json = {}) {
    super({
      ...json,
    });
  }
}
